<div class="section-list card issue-section-container">
    <div class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">

            <span class="navbar-brand mb-0 h1">

                <i class="far fa-window-close text-danger" data-fa-transform="shrink-3"></i>
                Issues

            </span>
            <div class="stats">
                <span class="badge badge-danger badge-err" (click)="showErrorAll()"
                    matTooltip="Click to show all errors">{{getIssueCount()}}</span>
                <span class="badge badge-success badge-err" (click)="showErrorValidated()" *ngIf="uiStatusOpen"
                    matTooltip="Click to show validated errors">Checked {{issuecheckedcount}}</span>
                <span class="badge badge-secondary badge-err" (click)="showErrorUnValidated()"
                    matTooltip="Click to show pending errors">UnChecked
                    {{issueErrorCountToValidate}}</span>
                <span class="badge badge-primary badge-err" (click)="showErrorNot()"
                    matTooltip="Click to show issues marked as not an error">
                    <app-check-box-icon [checked]="svFilter.filter_status_type"></app-check-box-icon> Not Error
                    {{issuenoerrorcount}}
                </span>
                <span class="badge badge-primary badge-err" (click)="showRepeated()"
                    matTooltip="Click to show marked as repeated by user">
                    <app-check-box-icon [checked]="svFilter.show_issueRepeated"></app-check-box-icon> Repeated
                    {{issueRepeatedCount}}
                </span>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                    <ul *permusr="controlEnum.BTN_SUPERV_VALIDATOR" class="nav navbar-nav ml-auto">
                    </ul>
                </div>
            </div>
        </nav>
    </div>

    <div class="card-body card-body-mat-tab nopadding">
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <div class="issue-validator-container container-fluid" *ngIf="issue">
            <div class="row nopadding">
                <div class="col">
                    <table class="issue-panel-info">
                        <thead>
                            <tr>
                                <th class="col-panel-locator">Panel Locator</th>
                                <th class="col-status">Status</th>
                                <th class="col-validation-date">Validation Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> <button type="button" *ngIf="!issueChangePanelActive"
                                        class="btn-change-locator btn btn-outline-secondary btn-sm "
                                        (click)="issueChangePanel(issue,true)"
                                        matTooltip="Change panel locator. You can choose a new locator on the map.">
                                        <i class="fas fa-exchange-alt"></i>
                                    </button>
                                    <div class="div-change-locator">
                                        <button type="button" *ngIf="issueChangePanelActive"
                                            class="btn btn-danger btn-sm btn-issue-panel-change-cancel"
                                            (click)="issueChangePanel(issue,false)"
                                            matTooltip="Cancel panel change operation">
                                            <i class="fas fa-exchange-alt ml-2 mr-2"></i> Cancel panel change
                                        </button>
                                    </div>
                                    <b>{{uiLocator(issue)}}</b>
                                    <!--                                     <div class="" style="float: right;height: 0;position: relative;top: -3px;">
                                    <app-panellocator #panellocator [issue]="issue" (panelChangeEvent)="panellocator_panelChangeEvent_handler($event)"></app-panellocator>
                                    </div> -->

                                </td>
                                <td class="col-status">
                                    <div class="btn-group" dropdown>
                                        <button id="button-basic" dropdownToggle type="button"
                                            matTooltip="Click here to change status of defect"
                                            class="btn dropdown-toggle btn-sm"
                                            [ngClass]="issue.info.status==supervisionErrorStatusEnum.validated ? 'btn-success':'btn-secondary'"
                                            aria-controls="dropdown-basic">
                                            {{ui_issueGetstatusDesc()}} <span class="caret"></span>
                                        </button>
                                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                                            aria-labelledby="button-basic">
                                            <li role="menuitem"><a class="dropdown-item"
                                                    (click)="changeStatus_click(supervisionErrorStatusEnum.validated)"><i
                                                        class="fas fa-check"></i> Validate</a></li>
                                            <li role="menuitem"><a class="dropdown-item"
                                                    (click)="changeStatus_click(supervisionErrorStatusEnum.tovalidate)">Not
                                                    Validated</a></li>
                                        </ul>
                                    </div>



                                    <ng-container *ngIf="ui_issueStatusTypeIsError(issue)">
                                        <span class="badge badge-info ml-2" style="font-size: 100%"
                                            matTooltip="This issue was marked as not error. To remove you need to select an issue type."><i
                                                class="fas fa-times"></i>
                                            No Error</span>
                                    </ng-container>
                                    <ng-container *ngIf="ui_issueStatusTypeIsRepeated(issue)">
                                        <span class="badge badge-info ml-2" style="font-size: 100%"
                                            matTooltip="This issue was marked as repeated by user. This error will not show up in the final results."><i
                                                class="far fa-clone"></i>
                                            Repeated</span>
                                    </ng-container>
                                </td>
                                <td>
                                    {{issue.info?.validation_date | date:'dd-MM-yyyy HH:mm:ss' }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <b>Issue detected on flight: </b>{{issue.flight?.name}} <b>Image:</b>
                                    {{issue?.image?.name}} <b>Date/Time:</b>
                                    {{issue.info?.date | date:'dd-MM-yyyy HH:mm:ss' }}
                                </td>


                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-imageslider #imageSlider [load_type]="'FLIGHT'" [issue]="issue" [issueList]="issues"
                        (onThumbRightClick)="thumbOnRightClick($event)"></app-imageslider>
                </div>
            </div>
            <app-issueview [issue]="issue" [issueList]="issues" [site]="site" [options]="issueEditOptions"
                (onActionClick)="issueviewHandler($event)"></app-issueview>

            <div class="row mt-2">
                <div class="col">
                    <div class="issue-actions btn-issue-err btn-col">
                        <h6>Select Issue type or confirm actual selection</h6>
                        <div class="row no-gutters row-cols-6">
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.E1PC)"
                                    (click)="issueChangeError(issue,issueTypeEnum.E1PC)"
                                    matTooltip="Mark error as Hot Spot">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.E1PC">
                                    </app-ex-issuerrortype> Hot Spot
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.PCS)"
                                    (click)="issueChangeError(issue,issueTypeEnum.PCS)"
                                    matTooltip="Mark error as Several Hot Spots">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.PCS">
                                    </app-ex-issuerrortype> N Hot Spots
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.E1CC)"
                                    (click)="issueChangeError(issue,issueTypeEnum.E1CC)"
                                    matTooltip="Mark error as Hot Cell">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.E1CC">
                                    </app-ex-issuerrortype> Hot Cell
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.CCS)"
                                    (click)="issueChangeError(issue,issueTypeEnum.CCS)"
                                    matTooltip="Mark error as Several Hot Cells">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.CCS">
                                    </app-ex-issuerrortype> N Hot Cells
                                </button>
                            </div>

                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SMC)"
                                    (click)="issueChangeError(issue,issueTypeEnum.SMC)"
                                    matTooltip="Mark error as Bypass diode">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.SMC">
                                    </app-ex-issuerrortype> Bypass diode
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.PID)"
                                    (click)="issueChangeError(issue,issueTypeEnum.PID)"
                                    matTooltip="Mark error as Potencial-induced degradation">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.PID">
                                    </app-ex-issuerrortype> Potencial-induced degradation
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DRT)"
                                    (click)="issueChangeError(issue,issueTypeEnum.DRT)"
                                    matTooltip="Mark error as Dirt">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.DRT">
                                    </app-ex-issuerrortype> Dirt
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SDW)"
                                    (click)="issueChangeError(issue,issueTypeEnum.SDW)"
                                    matTooltip="Mark error as Shadows">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.SDW">
                                    </app-ex-issuerrortype> Shadow
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.FUS)"
                                    (click)="issueChangeError(issue,issueTypeEnum.FUS)"
                                    matTooltip="Mark error as broken fuses">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.FUS">
                                    </app-ex-issuerrortype> Fuses
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.BRK)"
                                    (click)="issueChangeError(issue,issueTypeEnum.BRK)"
                                    matTooltip="Mark error as broken">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.BRK">
                                    </app-ex-issuerrortype> Broken
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DSC)"
                                    (click)="issueChangeError(issue,issueTypeEnum.DSC)"
                                    matTooltip="Mark error as disconnected panel">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.DSC">
                                    </app-ex-issuerrortype> Disconnected
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.SHC)"
                                    (click)="issueChangeError(issue,issueTypeEnum.SHC)"
                                    matTooltip="Mark error as short circuit">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.SHC">
                                    </app-ex-issuerrortype> Short circuit
                                </button>
                            </div>                            
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    [ngClass]="ui_btn_errortype_class(issue,issueTypeEnum.DLM)"
                                    (click)="issueChangeError(issue,issueTypeEnum.DLM)"
                                    matTooltip="Mark error as delamination">
                                    <app-ex-issuerrortype [errortype]="issueTypeEnum.DLM">
                                    </app-ex-issuerrortype> Delamination
                                </button>
                            </div>   
                            <div class="col">
                            </div>
                            <div class="col">
                            </div>
                            <div class="col">
                            </div>

                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                    [ngClass]="ui_btn_statustype_class(issue,supervisionErrorStatusEnum.noerror)"
                                    (click)="issueNoError(issue)"
                                    matTooltip="Mark issue as NO error detected. To remove you need to select an issue type.">
                                    <i class="fas fa-times"></i> No Error
                                </button>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                    [ngClass]="ui_btn_repeated_class(issue)" (click)="issueRepeated(issue)"
                                    matTooltip="Mark issue as repeated. This occurs when the error is detected in diferent images.">
                                    <i class="far fa-clone"></i> Repeated
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-3 issue-actions-buttons">
                    <button type="button" class="btn btn-outline-success btn-block" (click)="saveIssue_click(issue)"
                        [disabled]="!isvalid()" matTooltip="Save issue only">
                        <i class="fas fa-save"></i>
                    </button>
                </div>
                <div class="col issue-actions-buttons">
                    <button type="button" class="btn btn-outline-success btn-block" (click)="confirmIssue_click(issue)"
                        [disabled]="!isvalid()" matTooltip="Save issue and mark as checked">
                        <i class="fas fa-check"></i>
                    </button>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col">
                    <div class="card  border border-danger" *ngIf="issueChanged">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-2"><b>Issue type changed.</b></div>
                                <div class="col">
                                    <div [innerHTML]="ui_showEditStatus()"></div>
                                </div>
                                <div class="col-2">
                                    <div class="text-right"><button type="button" class="btn btn-outline-danger btn-sm"
                                            (click)="issueCancelChange(issue)">
                                            <i class="fas fa-redo"></i> Cancel change</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="button-nav-navigation btn-group ml-auto d-flex justify-content-end">
                        <button type="button" class="btn btn-secondary" (click)="itemmove(issue,'FIRST')"
                            matTooltip="First item (Ctrl+Left arrow)">
                            <i class="fas fa-angle-double-left"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="itemmove(issue,'PREV')"
                            matTooltip="Previous item (Left arrow)">
                            <i class="fas fa-angle-left"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="itemmove(issue,'NEXT')"
                            matTooltip="Next item (Right arrow)">
                            <i class="fas fa-angle-right"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="itemmove(issue,'LAST')"
                            matTooltip="Last item (Ctrl+Right arrow)">
                            <i class="fas fa-angle-double-right"></i>
                        </button>
                    </div>
                </div>

            </div>
        </div>


    </div>



</div>

<app-frms-ctxmenu #ctxmenu></app-frms-ctxmenu>